export function checkLightBackground(currentColor: Array<number>) {
  const isLightBackground = currentColor
    ? 0.2126 * currentColor[0] + 0.7152 * currentColor[1] + 0.0722 * currentColor[2] > 0.5
    : true;
  return isLightBackground;
}
